// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nbz-F","questions":"styles_questions__24pFi","footer":"styles_footer__zzH_L"};